import { MinusIcon, AddIcon } from "@chakra-ui/icons";
import {
    Accordion,
    AccordionButton,
    AccordionIcon,
    AccordionItem,
    AccordionPanel,
    Box,
    Button,
    CloseButton,
    Divider,
    Drawer,
    DrawerBody,
    DrawerContent,
    DrawerHeader,
    DrawerOverlay,
    Flex,
    Image,
    Link,
    Text,
    VStack,
    IconButton,
} from "@chakra-ui/react";
import React from "react";
import { IoCartOutline } from "react-icons/io5";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { currentItem } from "../../actions/current_item";
import {
    addDeliveryPickupDetails,
    removeDeliveryPickupDetails,
} from "../../actions/delivery_pickup_action";
import { orderCalculation } from "../../actions/order_actions";
import {
    addItem,
    clearItems,
    deleteItem,
    minusItem,
    updateItemInstruction,
} from "../../actions/order_items";
import Colors from "../../assets/colors/Colors";
import lock from "../../assets/images/lock.svg";
import * as Constants from "../../constants/Constants";
import { isValidArray, twofix } from "../../helpers/utils/Utils";
import AuthLayout from "../../modules/auth/screens/AuthLayout";
import { GrubDialogAlert, GrubInput, GrubTitleText } from "../index";
import GrubTimeSlotDialog from "../timeslotdialog/GrubTimeSlotDialog";
import { useGrubCartDialogDrawer } from "./useGrubCartDialogDrawer";

const GrubCartDrawer = (props) => {
    const {
        isModalOpen,
        formik,
        isOpenes,
        touchedRef,
        cancelRef,
        isTimeSlotModalOpen,
        handleCloseModal,
        handleAddQuantity,
        handleMinusQuantity,
        handleDeleteRow,
        handleInstructionChange,
        handleAlertModalOpen,
        handleAllDelete,
        handleClose,
        handleCheckout,
        addToast,
        handleCheckTimeSlot,
        handleTimeSlotClose,
    } = useGrubCartDialogDrawer(props);

    const renderInstructionInput = (item, index) => {
        let isValidValue =
            isValidArray(touchedRef?.current) &&
            touchedRef?.current?.find(
                (instruction) => instruction.key === item.new_identity
            )?.value &&
            isValidArray(formik.errors.instruction) &&
            formik.errors.instruction?.find(
                (instruction) => instruction.key === item.new_identity
            )?.value;
        let instructionIndex = formik.values.instruction.findIndex(
            (instruction) => instruction.key === item.new_identity
        );
        return (
            <>
                <GrubInput
                    id={`instruction-${index}`}
                    placeholder={"Enter Instruction"}
                    handleInputChange={(e) => {
                        handleInstructionChange(item, e.target.value); // Modify this line
                    }}
                    inputValue={
                        formik.values.instruction?.[instructionIndex]?.value ||
                        ""
                    }
                    handleBlur={(e) => {
                        let index = formik.values.instruction.findIndex(
                            (instruction) =>
                                instruction.key === item.new_identity
                        );
                        if (index > -1) {
                            formik.setFieldValue("instruction", [
                                ...formik.values.instruction.slice(0, index),
                                {
                                    key: item.new_identity,
                                    value: formik.values.instruction[
                                        index
                                    ].value.trim(),
                                },
                                ...formik.values.instruction.slice(index + 1),
                            ]);
                        }
                    }}
                    variant={"posBasicInput"}
                    posInput={true}
                    darkPlaceholder={true}
                    background={Colors.posviewbgcolor}
                    inputType={"text"}
                    inputError={isValidValue ? true : undefined}
                />
                {isValidValue && (
                    <GrubTitleText
                        isCategoryText={true}
                        mt="0.5rem"
                        color={Colors.posCancleButtonRed}
                        name={
                            formik.errors.instruction?.find(
                                (instruction) =>
                                    instruction.key === item.new_identity
                            )?.value
                        }
                    />
                )}
            </>
        );
    };

    const renderModifier = (item, totalPriceWithQuantity) => {
        const finalResult = item.is_modifier_product
            ? item.modifier_set.reduce((acc, single) => {
                  if (single.selected_modifiers.length > 0) {
                      const selectedNames = single.selected_modifiers
                          .map((mod) => mod.name)
                          .join(", ");
                      return acc ? `${acc}, ${selectedNames}` : selectedNames;
                  }
                  return acc;
              }, "")
            : "";

        return (
            <Flex
                alignItems="center"
                justifyContent={finalResult ? "space-between" : "flex-end"}
                width="100%"
                pr="0.5rem"
            >
                {finalResult && (
                    <GrubTitleText
                        key={"key1"}
                        isCategoryText={true}
                        name={finalResult}
                        color={Colors.couponDropDownLabelColor}
                    />
                )}
                <Box
                    display="flex"
                    alignItems="center"
                    justifyContent="flex-end"
                    width="6rem"
                    mr="0.5rem"
                >
                    <GrubTitleText
                        isCategoryText={true}
                        color={Colors.posTextInfo}
                        name={`$${totalPriceWithQuantity}`}
                    />
                </Box>
            </Flex>
        );
    };

    return (
        <Flex>
            <AuthLayout isOpen={isModalOpen} onClose={handleCloseModal} />
            <GrubDialogAlert
                leastDestructiveRef={cancelRef}
                onClose={handleClose}
                isOpen={isOpenes}
                title={Constants.DEACTIVE_TITLE}
                discription={Constants.DEACTIVE_DISCRIPTION}
                onClick={handleAllDelete}
                buttonNames={["No", "Yes"]}
            />
            <GrubTimeSlotDialog
                isOpen={isTimeSlotModalOpen}
                handleCheckout={handleCheckout}
                onClose={handleTimeSlotClose}
            />
            <Drawer
                isOpen={props.isOpen}
                placement="right"
                onClose={props.onClose}
                size={"sm"}
            >
                <DrawerOverlay />
                <DrawerContent
                    bg={Colors.loginAuthBackground}
                    borderLeft="0.06rem solid #e2e8f0"
                    width="25rem"
                >
                    <DrawerHeader
                        pl={"0.3rem"}
                        pr={"0.3rem"}
                        pt={{ base: "0.88rem", md: 4 }}
                        pb={{ base: "0.88rem", md: 4 }}
                    >
                        <Flex align="center">
                            <Box display={{ base: "block", md: "none" }}>
                                <CloseButton
                                    right="0.1rem"
                                    top="0.5rem"
                                    onClick={props.onClose}
                                />
                            </Box>
                            <IoCartOutline
                                style={{
                                    fontSize: "1.5rem",
                                    marginRight: "0.5rem",
                                    marginLeft: "1.24rem",
                                    color: Colors.couponDropDownLabelColor,
                                }}
                            />
                            <GrubTitleText
                                isHeading={true}
                                color={Colors.posTextInfo}
                                name={"Your Cart"}
                            />
                            <Link
                                color={Colors.posNavbarLink}
                                fontStyle="normal"
                                fontWeight={300}
                                fontSize={{ base: "0.87rem", md: "0.94rem" }}
                                lineHeight={{ base: "1.20rem", md: "1.17rem" }}
                                letterSpacing="-0.02em"
                                pr="1rem"
                                ml="auto"
                                onClick={() => handleAlertModalOpen(true)}
                            >
                                Clear All
                            </Link>
                        </Flex>
                    </DrawerHeader>
                    <Divider />
                    <DrawerBody
                        pl={"0.4rem"}
                        pr={"0.4rem"}
                        flex={"1"}
                        sx={{
                            "&::-webkit-scrollbar": {
                                display: "none",
                            },
                            msOverflowStyle: "none",
                            scrollbarWidth: "none",
                        }}
                    >
                        <Accordion
                            allowToggle
                            overflowY={{ base: "auto", md: "auto" }}
                        >
                            {props.order_items.map((item, index) => {
                                const totalPriceWithQuantity = (
                                    parseFloat(item.sale_price) * item.quantity
                                ).toFixed(2);
                                return (
                                    <AccordionItem
                                        key={index}
                                        borderBottom="none"
                                        overflowX={"hidden"}
                                    >
                                        <AccordionButton
                                            border={"none"}
                                            as="div"
                                            p={0}
                                            _hover={{
                                                bg: Colors.noProductBgColor,
                                            }}
                                        >
                                            <AccordionIcon />
                                            <Flex
                                                justify="space-between"
                                                width="100%"
                                                py="0.5rem"
                                                borderBottom={
                                                    index ===
                                                    props.order_items.length - 1
                                                        ? "none"
                                                        : "0.06rem solid #e2e8f0"
                                                }
                                            >
                                                {/* {item?.image_url ? (
                                                    <Image
                                                        src={
                                                            item?.image_url ||
                                                            noimage
                                                        }
                                                        alt={
                                                            "Image Coming Soon"
                                                        }
                                                        boxSize="4.17rem"
                                                        mr="0.6rem"
                                                        onError={(e) => {
                                                            e.target.src =
                                                                noimage;
                                                        }}
                                                    />
                                                ) : ( */}
                                                <Box
                                                    bg={"#e0e0e0"}
                                                    height="4rem"
                                                    width="4.50rem"
                                                    mr="0.6rem"
                                                    backgroundImage={
                                                        item?.image_url
                                                    }
                                                    backgroundSize="cover"
                                                />
                                                {/* )}  */}
                                                <VStack
                                                    align="start"
                                                    justifyContent="flex-start"
                                                    width="100%"
                                                >
                                                    <Flex
                                                        alignItems="center"
                                                        justifyContent="space-between"
                                                        width="100%"
                                                    >
                                                        <Text
                                                            fontWeight={500}
                                                            width="50%"
                                                            fontSize={{
                                                                base: "0.87rem",
                                                                md: "0.94rem",
                                                            }}
                                                            lineHeight={{
                                                                base: "1.20rem",
                                                                md: "1.17rem",
                                                            }}
                                                            letterSpacing="-0.02em"
                                                            color={
                                                                Colors.posTextInfo
                                                            }
                                                            textAlign={"left"}
                                                        >
                                                            {item.name}
                                                        </Text>
                                                        <Flex width="50%">
                                                            <Box
                                                                display="flex"
                                                                alignItems="center"
                                                                justifyContent="center"
                                                                flex="1"
                                                                pr="0.5rem"
                                                            >
                                                                <GrubTitleText
                                                                    isHeading={
                                                                        true
                                                                    }
                                                                    color={
                                                                        Colors.posTextInfo
                                                                    }
                                                                    name={`$${parseFloat(
                                                                        item.sale_price
                                                                    ).toFixed(
                                                                        2
                                                                    )}`}
                                                                />
                                                            </Box>
                                                            <Flex
                                                                alignItems="start"
                                                                width="fit-content"
                                                                p={1}
                                                                borderRadius="1.5rem"
                                                                border="0.05rem solid #E2E8F0"
                                                                gap="1"
                                                            >
                                                                <IconButton
                                                                    // icon={
                                                                    //     <MinusIcon
                                                                    //         boxSize={
                                                                    //             2
                                                                    //         }
                                                                    //         color={
                                                                    //             Colors.grubAddBackground
                                                                    //         }
                                                                    //     />
                                                                    // }
                                                                    icon={
                                                                        <Text
                                                                            color={
                                                                                Colors.grubHeaderColor
                                                                            }
                                                                            fontSize={{
                                                                                base: "0.75rem",
                                                                                md: "0.88rem",
                                                                            }}
                                                                        >
                                                                            -
                                                                        </Text>
                                                                    }
                                                                    border="0.05rem solid #E2E8F0"
                                                                    borderRadius="100%"
                                                                    variant="posghost"
                                                                    bg={
                                                                        Colors.grubBackgroundColor
                                                                    }
                                                                    onClick={(
                                                                        e
                                                                    ) => {
                                                                        e.stopPropagation();
                                                                        handleMinusQuantity(
                                                                            item
                                                                        );
                                                                    }}
                                                                    onKeyDown={(
                                                                        e
                                                                    ) => {
                                                                        if (
                                                                            e.key ===
                                                                            "Enter"
                                                                        ) {
                                                                            e.preventDefault();
                                                                        }
                                                                    }}
                                                                    minWidth="1.5rem"
                                                                    height="1.7rem"
                                                                    aspectRatio="1/1"
                                                                    display="flex"
                                                                    alignItems="center"
                                                                    justifyContent="center"
                                                                />
                                                                {/* <Button
                                                                    border="0.05rem solid #E2E8F0"
                                                                    borderRadius="100%"
                                                                    variant="posghost"
                                                                    // size="xs"
                                                                    bg={
                                                                        Colors.grubBackgroundColor
                                                                    }
                                                                    onClick={(
                                                                        e
                                                                    ) => {
                                                                        e.stopPropagation();
                                                                        handleMinusQuantity(
                                                                            item
                                                                        );
                                                                    }}
                                                                    onKeyDown={(
                                                                        e
                                                                    ) => {
                                                                        if (
                                                                            e.key ===
                                                                            "Enter"
                                                                        ) {
                                                                            e.preventDefault();
                                                                        }
                                                                    }}
                                                                    minWidth="1.5rem"
                                                                    height="1.7rem"
                                                                    aspectRatio="1/1"
                                                                    display="flex"
                                                                    alignItems="center"
                                                                    justifyContent="center"
                                                                >
                                                                    <Text
                                                                        color={
                                                                            Colors.grubHeaderColor
                                                                        }
                                                                        fontSize={{
                                                                            base: "0.75rem",
                                                                            md: "0.88rem",
                                                                        }}
                                                                        lineHeight="1"
                                                                    >
                                                                        -
                                                                    </Text>
                                                                </Button> */}
                                                                <GrubTitleText
                                                                    isHeading={
                                                                        true
                                                                    }
                                                                    color={
                                                                        Colors.posTextInfo
                                                                    }
                                                                    mt="0.3rem"
                                                                    name={
                                                                        item.quantity
                                                                    }
                                                                />
                                                                <IconButton
                                                                    icon={
                                                                        <Text
                                                                            color={
                                                                                Colors.grubBackgroundColor
                                                                            }
                                                                            fontSize={{
                                                                                base: "0.75rem",
                                                                                md: "0.88rem",
                                                                            }}
                                                                        >
                                                                            +
                                                                        </Text>
                                                                    }
                                                                    border="0.05rem solid #E2E8F0"
                                                                    borderRadius="100%"
                                                                    bg={
                                                                        Colors.grubAddBackground
                                                                    }
                                                                    onClick={(
                                                                        e
                                                                    ) => {
                                                                        e.stopPropagation();
                                                                        handleAddQuantity(
                                                                            item
                                                                        );
                                                                    }}
                                                                    onKeyDown={(
                                                                        e
                                                                    ) => {
                                                                        if (
                                                                            e.key ===
                                                                            "Enter"
                                                                        ) {
                                                                            e.preventDefault();
                                                                        }
                                                                    }}
                                                                    minWidth="1.5rem"
                                                                    height="1.7rem"
                                                                    aspectRatio="1/1"
                                                                    display="flex"
                                                                    alignItems="center"
                                                                    justifyContent="center"
                                                                />
                                                                {/* <Button
                                                                    border="0.05rem solid #E2E8F0"
                                                                    borderRadius="0.75rem"
                                                                    size="xs"
                                                                    bg={
                                                                        Colors.grubAddBackground
                                                                    }
                                                                    onClick={(
                                                                        e
                                                                    ) => {
                                                                        e.stopPropagation();
                                                                        handleAddQuantity(
                                                                            item
                                                                        );
                                                                    }}
                                                                    onKeyDown={(
                                                                        e
                                                                    ) => {
                                                                        if (
                                                                            e.key ===
                                                                            "Enter"
                                                                        ) {
                                                                            e.preventDefault();
                                                                        }
                                                                    }}
                                                                    minWidth="1.5rem"
                                                                >
                                                                    <Text
                                                                        color={
                                                                            Colors.grubBackgroundColor
                                                                        }
                                                                        fontSize={{
                                                                            base: "0.75rem",
                                                                            md: "0.88rem",
                                                                        }}
                                                                    >
                                                                        +
                                                                    </Text>
                                                                </Button> */}
                                                            </Flex>
                                                        </Flex>
                                                    </Flex>
                                                    {renderModifier(
                                                        item,
                                                        totalPriceWithQuantity
                                                    )}
                                                </VStack>
                                            </Flex>
                                        </AccordionButton>
                                        <AccordionPanel
                                            pb={2}
                                            border="none"
                                            pt={0}
                                            px={0}
                                        >
                                            <Flex
                                                justify="space-between"
                                                width="100%"
                                                borderBottom={
                                                    index ===
                                                    props.order_items.length - 1
                                                        ? "none"
                                                        : "0.06rem solid #e2e8f0"
                                                }
                                            >
                                                <Box
                                                    boxSize="4.17rem"
                                                    mr="0.6rem"
                                                />
                                                <VStack
                                                    align="start"
                                                    justifyContent="flex-start"
                                                    width="100%"
                                                >
                                                    <GrubTitleText
                                                        isInstuction={true}
                                                        mt="0.3rem"
                                                        mb="0.1rem"
                                                        color={
                                                            Colors.posTextInfo
                                                        }
                                                        name={
                                                            "Special Instructions:"
                                                        }
                                                    />
                                                    {renderInstructionInput(
                                                        item,
                                                        index
                                                    )}
                                                    <Flex
                                                        mt="0.3rem"
                                                        mb="0.3rem"
                                                    >
                                                        {item.modifier_set &&
                                                            item.modifier_set
                                                                .length > 0 && (
                                                                <Link
                                                                    variant="link"
                                                                    color={
                                                                        Colors.posNavbarLink
                                                                    }
                                                                    onClick={() => {
                                                                        if (
                                                                            props
                                                                                .payments
                                                                                .length >
                                                                            0
                                                                        ) {
                                                                            addToast(
                                                                                {
                                                                                    alertStatus:
                                                                                        Constants.TOAST_TYPE_WARNING,
                                                                                    alertTitle:
                                                                                        Constants.TOAST_HEADING_WARNING,
                                                                                    alertDescription:
                                                                                        Constants.HALF_PAYMENT,
                                                                                }
                                                                            );
                                                                            return;
                                                                        }
                                                                        let updateItem =
                                                                            Object.assign(
                                                                                {},
                                                                                item
                                                                            );
                                                                        updateItem.is_update = true;
                                                                        props.currentItem(
                                                                            updateItem
                                                                        );
                                                                        props.editModelOpen();
                                                                    }}
                                                                    fontStyle="normal"
                                                                    fontWeight={
                                                                        400
                                                                    }
                                                                    fontSize={
                                                                        "0.75rem"
                                                                    }
                                                                    lineHeight="0.94rem"
                                                                    letterSpacing="-0.02em"
                                                                >
                                                                    Edit
                                                                </Link>
                                                            )}
                                                        <Link
                                                            variant="link"
                                                            color={
                                                                Colors.errorColor
                                                            }
                                                            onClick={() =>
                                                                handleDeleteRow(
                                                                    item
                                                                )
                                                            }
                                                            fontStyle="normal"
                                                            fontWeight={400}
                                                            fontSize="0.75rem"
                                                            lineHeight="0.94rem"
                                                            letterSpacing="-0.02em"
                                                            ml="0.44rem"
                                                        >
                                                            Remove
                                                        </Link>
                                                    </Flex>
                                                </VStack>
                                            </Flex>
                                        </AccordionPanel>
                                    </AccordionItem>
                                );
                            })}
                        </Accordion>
                    </DrawerBody>
                    <Box
                        width="full"
                        zIndex="10"
                        pl={"0.8rem"}
                        pr={"0.8rem"}
                        position="sticky"
                        bg={Colors.loginAuthBackground}
                        bottom={0}
                        right={2}
                        left={1}
                    >
                        <Flex
                            justify="space-between"
                            mt={{ base: "0.5rem", md: "0.5rem" }}
                        >
                            <GrubTitleText
                                isHeading={true}
                                color={Colors.posTextInfo}
                                name={"Subtotal"}
                            />
                            <GrubTitleText
                                isHeading={true}
                                color={Colors.posTextInfo}
                                name={`$${twofix(props.order.total)}`}
                            />
                        </Flex>
                        <Flex justify="space-between" mt={"0.5rem"}>
                            <GrubTitleText
                                isHeading={true}
                                color={Colors.posTextInfo}
                                name={"Total Tax"}
                            />
                            <GrubTitleText
                                isHeading={true}
                                color={Colors.posTextInfo}
                                name={`$${twofix(props.order.tax_collected - props.order.fee_collected)}`}
                            />
                        </Flex>
                        {props.order.fee_collected > 0 && (
                        <Flex justify="space-between" mt={"0.5rem"}>
                            <GrubTitleText
                                isHeading={true}
                                color={Colors.posTextInfo}
                                name={"Total Fee"}
                            />
                            <GrubTitleText
                                isHeading={true}
                                color={Colors.posTextInfo}
                                name={`$${twofix(props.order.fee_collected)}`}
                            />
                        </Flex>
                        )}
                        <Box>
                            {null != props.order.tip_type &&
                                undefined != props.order.tip_type &&
                                "" != props.order.tip_type && (
                                    <Flex justify="space-between" mt={"0.5rem"}>
                                        <GrubTitleText
                                            isHeading={true}
                                            color={Colors.posTextInfo}
                                            name={"Total Tip"}
                                        />
                                        <GrubTitleText
                                            isHeading={true}
                                            color={Colors.posTextInfo}
                                            name={`$${twofix(
                                                props.order.order_tip_amount
                                            )}`}
                                        />
                                    </Flex>
                                )}
                        </Box>
                        <Flex
                            justify="space-between"
                            mt={"0.5rem"}
                            mb={{ base: "0rem", md: "0.88rem" }}
                        >
                            <GrubTitleText
                                isHeading={true}
                                color={Colors.posTextInfo}
                                name={"Total"}
                            />
                            <GrubTitleText
                                isHeading={true}
                                color={Colors.posTextInfo}
                                name={`$${twofix(props.order.balance)}`}
                            />
                        </Flex>
                        <Button
                            bg={Colors.grubButtonFontColor}
                            width="100%"
                            mb={{ base: "0.5rem", md: "1rem" }}
                            mt={{ base: "1rem", md: 4 }}
                            onClick={handleCheckTimeSlot}
                        >
                            <Image src={lock} alt="Image" mr="0.63rem" />
                            Checkout
                        </Button>
                    </Box>
                </DrawerContent>
            </Drawer>
        </Flex>
    );
};

function mapDispatchToProps(dispatch) {
    return bindActionCreators(
        {
            addItem,
            minusItem,
            currentItem,
            orderCalculation,
            clearItems,
            deleteItem,
            removeDeliveryPickupDetails,
            updateItemInstruction,
            addDeliveryPickupDetails,
        },
        dispatch
    );
}

function mapStateToProps(state) {
    return {
        delivery_pickup: state.delivery_pickup,
        order_items: state.order_items,
        payments: state.payments,
        order: state.order,
        user: state.user,
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(GrubCartDrawer);
